var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "downloads", title: "Downloads" } },
    [
      _vm._v("\n  While this agreement continues, the\n  "),
      _c("em", [_vm._v("Company")]),
      _vm._v("\n  agrees to make the latest versions of\n  "),
      _c("em", [_vm._v("Pro Icons")]),
      _vm._v("\n  and\n  "),
      _c("em", [_vm._v("Pro Software")]),
      _vm._v("\n  available to download via the\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v("\n  .\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }